import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-aplum mt-32">
        <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
                <div className="font-serif-display text-3xl tracking-tighter text-aplum">A_Plum</div>
                <p className="font-sans-display text-xs uppercase tracking-widest-x text-aplum-dim mt-2">
                    Alexandra Plum — Studio
                </p>
            </div>
            <div className="flex flex-col gap-3">
                <span className="font-sans-display text-[10px] uppercase tracking-widest-x text-aplum-dim">Navigate</span>
                <Link to="/" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">Home</Link>
                <Link to="/about" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">About</Link>
                <Link to="/portfolio" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">Portfolio</Link>
                <Link to="/contact" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">Contact</Link>
            </div>
            <div className="flex flex-col gap-3">
                <span className="font-sans-display text-[10px] uppercase tracking-widest-x text-aplum-dim">Elsewhere</span>
                <a href="mailto:hello@aplum.studio" data-testid="footer-email" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">hello@aplum.studio</a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="font-serif-display text-lg text-aplum hover:text-aplum-accent transition-colors">Instagram</a>
            </div>
        </div>
        <div className="px-6 md:px-12 lg:px-24 pb-10 flex flex-col md:flex-row gap-2 md:gap-0 items-start md:items-center justify-between">
            <span className="font-sans-display text-[11px] uppercase tracking-widest-x text-aplum-dim">© {new Date().getFullYear()} Alexandra Plum</span>
            <span className="font-sans-display text-[11px] uppercase tracking-widest-x text-aplum-dim">All works reproduced with permission of the artist</span>
        </div>
    </footer>
);

export default Footer;
